import { useEffect, useMemo } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import { useRouter } from 'next/router'

import { useLenis } from '@/contexts/lenis'
import { pageHasHero } from '@/utils/page'

import { WPPageData } from '@/types'

const headerContainedClassName = 'header-contained'

const LayoutController = ({ pageProps }: { pageProps: WPPageData }) => {
  const hasHero = useMemo(() => pageHasHero(pageProps), [pageProps])
  const router = useRouter()
  const { lenis } = useLenis()

  useGSAP(
    () => {
      if (!lenis) return

      const scrollTrigger = ScrollTrigger.create({
        start: () =>
          hasHero
            ? window.innerHeight - (window.innerWidth < 768 ? 96 : 171) // header height
            : 0,
        end: () => ScrollTrigger.maxScroll(document.documentElement) + 1,
        markers: false,
        toggleClass: {
          targets: document.documentElement,
          className: headerContainedClassName
        }
      })

      return () => {
        scrollTrigger?.kill()
      }
    },
    { dependencies: [lenis] }
  )

  useEffect(() => {
    gsap.delayedCall(0.3, () => {
      document.documentElement.classList.remove(headerContainedClassName)
    })
  }, [router.asPath])

  return null
}

export default LayoutController
